import { useEffect, useRef } from "react";
import { MultiSelect } from "react-multi-select-component";

const MultiselectComponent = ({
  label,
  options,
  selectedOptions,
  handleSetSelect,
  required = false,
  className,
  labelClassName = "",
}) => {
  const wrapperRef = useRef(null);

  useEffect(() => {
    const root = wrapperRef.current;
    if (!root) return;

    const positionPanel = () => {
      const trigger = root.querySelector(".dropdown-container");
      const panel = root.querySelector(".dropdown-content");
      if (!trigger || !panel) return;
      panel.style.transition = "none";
      panel.style.position = "fixed";
      panel.style.zIndex = "9999";
      const rect = trigger.getBoundingClientRect();
      panel.style.top = `${rect.bottom}px`;
      panel.style.left = `${rect.left}px`;
      panel.style.width = `${rect.width}px`;
    };

    const observer = new MutationObserver(positionPanel);
    observer.observe(root, { childList: true, subtree: true });
    window.addEventListener("scroll", positionPanel, true);
    window.addEventListener("resize", positionPanel);
    return () => {
      observer.disconnect();
      window.removeEventListener("scroll", positionPanel, true);
      window.removeEventListener("resize", positionPanel);
    };
  }, []);

  return (
    <div ref={wrapperRef}>
      <div className="flex items-center">
        <p className={labelClassName}>{label}</p>{" "}
        <span className="text-red-500 pl-1">{required && ` *`}</span>
      </div>
      <MultiSelect
        className={`${className}`}
        options={options}
        value={selectedOptions || []}
        onChange={(selected) => {
          handleSetSelect(selected);
        }}
        labelledBy="Select"
      />
    </div>
  );
};

export default MultiselectComponent;
